import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09291dc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-17 ant-col-xl-17" }, null, -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Faturar", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Emitir Documento Fiscal", -1))
const _hoisted_6 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_7 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_8 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Itens", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total dos Produtos", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descontos", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Frete", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Seguro", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"background-color":"#000066"}
}
const _hoisted_30 = { style: {"color":"white"} }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_34 = { class: "ant-input-group-wrapper" }
const _hoisted_35 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_36 = {
  class: "ant-input-group-addon",
  style: {"padding":"0px","background-color":"transparent","border":"none!important"}
}
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "ant-col ant-col-xs-12 ant-col-xl-7" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_40 = { class: "ant-input-group-wrapper" }
const _hoisted_41 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_42 = {
  class: "ant-input-group-addon",
  style: {"padding":"0px","background-color":"transparent","border":"none!important"}
}
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_45 = { class: "ant-input-group-wrapper" }
const _hoisted_46 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_47 = {
  class: "ant-input-group-addon",
  style: {"padding":"0px","background-color":"transparent","border":"none!important"}
}
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_49 = { class: "ant-row" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_51 = { class: "ant-row" }
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_53 = { class: "ant-row" }
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_colaborador = _resolveComponent("selecionar-colaborador")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_forma_pagamento = _resolveComponent("selecionar-forma-pagamento")!
  const _component_selecionar_marcador_nota_fiscal = _resolveComponent("selecionar-marcador-nota-fiscal")!
  const _component_card = _resolveComponent("card")!
  const _component_faturamento_itens = _resolveComponent("faturamento-itens")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_impostos = _resolveComponent("nota-fiscal-impostos")!
  const _component_nota_fiscal_frete = _resolveComponent("nota-fiscal-frete")!
  const _component_nota_fiscal_detalhes_pagamento = _resolveComponent("nota-fiscal-detalhes-pagamento")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_nota_fiscal_anexos = _resolveComponent("nota-fiscal-anexos")!
  const _component_nota_fiscal_historico = _resolveComponent("nota-fiscal-historico")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return ((_ctx.modalBase.computedVisivel))
    ? (_openBlock(), _createBlock(_component_a_modal, {
        key: 0,
        keyboard: false,
        visible: _ctx.modalBase.computedVisivel,
        "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
        width: "100%",
        centered: "",
        "wrap-class-name": _ctx.state.telaMobile ? 'full-modal ss-modal-vendas' : 'scroll-modal ss-modal-vendas'
      }, {
        title: _withCtx(() => [
          _createTextVNode("Faturamento " + _toDisplayString(_ctx.obtemTituloMovimentacao()), 1)
        ]),
        closeIcon: _withCtx(() => [
          _createVNode(_component_icone, { nome: "voltar" })
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_button, {
                type: "primary",
                size: "large",
                class: "ss-btn-acao-destaque",
                loading: _ctx.state.carregando || _ctx.state.carregandoItens,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.faturarVenda()))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_a_button, {
                type: "primary",
                size: "large",
                class: "ss-btn-acao-destaque",
                loading: _ctx.state.carregando || _ctx.state.carregandoItens,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitirNfe()))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_skeleton, {
            loading: _ctx.telaBase.carregando,
            paragraph: { rows: 10 }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.state.notaFiscal.itens.length,
                      disabled: "true"
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalProdutos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalDesconto, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_16)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalFrete, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_19)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalSeguro, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_22)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalOutrasDespesas, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_25)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalImpostos.valorAproximadoTributosTotal, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_28)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_a_popover, {
                      placement: "top",
                      title: "Incidência no Total da Venda"
                    }, {
                      content: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.notaFiscal.incidenciasCalculo, (incidencia, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: incidencia.incidencia + index
                          }, [
                            (incidencia.incidencia === 'TotalNota')
                              ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                  key: 0,
                                  style: {"margin-left":"0px!important"},
                                  checked: incidencia.valor,
                                  "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                                  disabled: true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["checked", "onUpdate:checked"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_30, [
                          _createTextVNode("Total do Faturamento "),
                          _createVNode(_component_icone, {
                            class: "ss-icone-informacao-campo",
                            nome: "informacoes-fp"
                          })
                        ]),
                        _createElementVNode("input", {
                          type: "text",
                          class: "ant-input hidden ss-movimento-input-totalizador",
                          style: {"background-color":"#000066","color":"white","font-weight":"900","font-size":"20px"},
                          value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalNotaFiscal, 2, true),
                          disabled: "true"
                        }, null, 8, _hoisted_31)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("span", _hoisted_34, [
                            _createElementVNode("span", _hoisted_35, [
                              _createElementVNode("span", _hoisted_36, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone",
                                  style: 'color: #a0aec1;padding: 8px;background-color: #ebeff2;border-radius: 3px;',
                                  nome: "numero"
                                })
                              ]),
                              _createVNode(_component_a_form_item, {
                                label: "Número",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    value: _ctx.UtilitarioMascara.mascararValor(_ctx.props.faturamento.numero, 0, false),
                                    disabled: "true"
                                  }, null, 8, _hoisted_37)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_a_form_item, {
                            label: "Data",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                horaMinuto: true,
                                dataSelecionada: _ctx.props.faturamento.dataMovimentacao,
                                "onUpdate:dataSelecionada": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.props.faturamento.dataMovimentacao) = $event)),
                                disabled: true
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, [
                            _createElementVNode("span", _hoisted_41, [
                              _createElementVNode("span", _hoisted_42, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone",
                                  style: 'color: #a0aec1;padding: 8px;background-color: #ebeff2;border-radius: 3px;',
                                  nome: "usuario"
                                })
                              ]),
                              _createVNode(_component_a_form_item, {
                                label: "Responsável",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_colaborador, {
                                    codigoSelecionado: _ctx.props.faturamento.codigoColaborador,
                                    "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.props.faturamento.codigoColaborador) = $event)),
                                    empresas: [_ctx.props.empresa],
                                    disabled: true,
                                    classCss: "ss-venda-dados-principais",
                                    limparSelecao: false,
                                    onKeydown: [
                                      _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                      _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                      _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"]))
                                    ]
                                  }, null, 8, ["codigoSelecionado", "empresas"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("span", _hoisted_45, [
                            _createElementVNode("span", _hoisted_46, [
                              _createElementVNode("span", _hoisted_47, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone",
                                  style: 'color: #a0aec1;padding: 8px;background-color: #ebeff2;border-radius: 3px;',
                                  nome: "cliente"
                                })
                              ]),
                              _createVNode(_component_a_form_item, {
                                label: "Cliente",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_pessoa, {
                                    empresas: [_ctx.props.empresa],
                                    classCss: "ss-venda-dados-principais",
                                    codigoSelecionado: _ctx.props.faturamento.codigoPessoa,
                                    "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.props.faturamento.codigoPessoa) = $event)),
                                    disabled: true,
                                    apresentarRelacoes: false,
                                    limparSelecao: false,
                                    onKeydown: [
                                      _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                      _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                      _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                                    ]
                                  }, null, 8, ["empresas", "codigoSelecionado"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_selecionar_forma_pagamento, {
                            apresentacaoPersonalizada: true,
                            empresas: [_ctx.props.empresa],
                            codigoSelecionado: _ctx.props.faturamento.codigoFormaPagamento,
                            classCss: "ss-venda-dados-principais",
                            disabled: true,
                            tipoMovimento: _ctx.ETipoMovimentoComercial.Vendas,
                            required: true,
                            limparSelecao: false,
                            onChange: _ctx.obterFormaPagamento,
                            onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"]))
                          }, null, 8, ["empresas", "codigoSelecionado", "tipoMovimento", "onChange"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_a_form_item, {
                            label: "Marcadores",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_marcador_nota_fiscal, {
                                marcadoresSelecionados: _ctx.state.marcadores,
                                "onUpdate:marcadoresSelecionados": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                                disabled: true
                              }, null, 8, ["marcadoresSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, { titulo: " " }, {
                    default: _withCtx(() => [
                      ((_ctx.state.notaFiscal.codigo > 0))
                        ? (_openBlock(), _createBlock(_component_a_tabs, {
                            key: 0,
                            defaultActiveKey: "1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tab_pane, {
                                key: "1",
                                tab: "ITENS"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_component_faturamento_itens, {
                                    dadosPessoaMovimento: _ctx.state.dadosPessoaMovimento,
                                    key: _ctx.state.chaveItens,
                                    totalVenda: _ctx.state.notaFiscal.totalNotaFiscal,
                                    incidencias: _ctx.state.notaFiscal.incidenciasCalculo,
                                    atualizarValores: false,
                                    itens: _ctx.state.notaFiscal.itens,
                                    editavel: false,
                                    buscarDadosFiscaisRecalcular: _ctx.state.buscarDadosFiscaisRecalcular,
                                    "onUpdate:buscarDadosFiscaisRecalcular": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.buscarDadosFiscaisRecalcular) = $event)),
                                    adicionarPrimeiroItem: _ctx.state.adicionarPrimeiroItem,
                                    carregando: _ctx.state.carregandoItens
                                  }, null, 8, ["dadosPessoaMovimento", "totalVenda", "incidencias", "itens", "buscarDadosFiscaisRecalcular", "adicionarPrimeiroItem", "carregando"]))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "2",
                                tab: "IMPOSTOS"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_nota_fiscal_impostos, {
                                    impostos: _ctx.state.notaFiscal.totalImpostos,
                                    "onUpdate:impostos": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.notaFiscal.totalImpostos) = $event)),
                                    incidenciasCalculo: _ctx.state.notaFiscal.incidenciasCalculo,
                                    "onUpdate:incidenciasCalculo": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.notaFiscal.incidenciasCalculo) = $event)),
                                    editavel: false
                                  }, null, 8, ["impostos", "incidenciasCalculo"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "3",
                                tab: "FRETE/OUTRAS DESPESAS"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_nota_fiscal_frete, {
                                    notaFiscal: _ctx.state.notaFiscal,
                                    "onUpdate:notaFiscal": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.notaFiscal) = $event)),
                                    editavel: false
                                  }, null, 8, ["notaFiscal"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "4",
                                tab: "DETALHES DO PAGAMENTO"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_spin, {
                                    spinning: _ctx.state.carregando
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_nota_fiscal_detalhes_pagamento, {
                                        empresa: _ctx.state.notaFiscal.codigoEmpresa,
                                        totalDetalhesPagamento: _ctx.state.totalDetalhesPagamento,
                                        detalhesPagamento: _ctx.state.notaFiscal.detalhesPagamento,
                                        "onUpdate:detalhesPagamento": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.notaFiscal.detalhesPagamento) = $event)),
                                        editavel: true,
                                        onAtualizarDetalhePagamento: _ctx.atualizarDetalhePagamento
                                      }, null, 8, ["empresa", "totalDetalhesPagamento", "detalhesPagamento", "onAtualizarDetalhePagamento"])
                                    ]),
                                    _: 1
                                  }, 8, ["spinning"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "5",
                                tab: "OBSERVAÇÕES"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Observações do Cliente",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_editor_html, {
                                            value: _ctx.state.notaFiscal.dadosAdicionais,
                                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.notaFiscal.dadosAdicionais) = $event)),
                                            disabled: false
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("div", _hoisted_54, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Observações Internas",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_editor_html, {
                                            value: _ctx.state.notaFiscal.observacoesInternas,
                                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.notaFiscal.observacoesInternas) = $event)),
                                            disabled: false
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "6",
                                tab: "ANEXOS"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_spin, {
                                    spinning: _ctx.state.carregando
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_nota_fiscal_anexos, {
                                        codigoRegistro: _ctx.state.notaFiscal.codigo,
                                        empresa: _ctx.state.notaFiscal.codigoEmpresa,
                                        editavel: true,
                                        anexos: _ctx.state.notaFiscal.anexos,
                                        "onUpdate:anexos": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.notaFiscal.anexos) = $event)),
                                        onAtualizarAnexo: _ctx.atualizarAnexo,
                                        onExcluirAnexo: _ctx.excluirAnexo
                                      }, null, 8, ["codigoRegistro", "empresa", "anexos", "onAtualizarAnexo", "onExcluirAnexo"])
                                    ]),
                                    _: 1
                                  }, 8, ["spinning"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "8",
                                tab: "HISTÓRICO"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_spin, {
                                    spinning: _ctx.state.carregando
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_nota_fiscal_historico, {
                                        registros: _ctx.state.registrosAtividade
                                      }, null, 8, ["registros"])
                                    ]),
                                    _: 1
                                  }, 8, ["spinning"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            retornoRequisicao: _ctx.modalBase.retornoRequisicao,
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
          }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
        ]),
        _: 1
      }, 8, ["visible", "wrap-class-name"]))
    : _createCommentVNode("", true)
}